import Transactions from './transaction-progressive';

export default Transactions;
